import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useSignatureSettingsUpdate() {
  return useFeatureSettingsUpdate('signatures');
}
